import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { HOMEPAGE_BRANDS_LISTING_PATH } from "utils/constants/paths";

const HomepageBrandsDetailsPage = Loadable(React.lazy(() => import("./View")));

export const HomepageBrandsRoute: IRouteItem = {
  path: HOMEPAGE_BRANDS_LISTING_PATH,
  element: React.createElement(HomepageBrandsDetailsPage),
  name: "Homepage Brands Listing",
};
